import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import moment from 'moment';
import ReactTable from 'react-table';
import _ from 'lodash';

import {
  defaultTableFiltering,
  formatMonthDay,
} from '../../../utils';

import '../style.css';
import { getUserTimesheetLink } from '../../timesheetNavigator/links';
import NewTabLink from '../../../components/NewTabLink/index';
import { getTicketLink } from '../../ticketViewer/links';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  allDistrictUserDailyTimeEntryGroups: PropTypes.array.isRequired,
  interval: PropTypes.array.isRequired,
});
/* eslint-enabled react/no-unused-prop-types */

const PerDiemReportTable = (props) => {
  const { allDistrictUserDailyTimeEntryGroups, interval } = props;

  const returnHeader = (day) => {
    const { dayOfWeek, iso8601 } = day;

    return (
      <div>
        <span>{dayOfWeek}</span><br />
        <span>{formatMonthDay(iso8601)}</span>
      </div>
    );
  };

  const returnHoursForTicketNumber = (ticketNumber, timeEntries) => {
    if (!ticketNumber || timeEntries.length === 0) {
      return null;
    }

    return _.find(timeEntries, (te) => {
      if (te.ticket_number) {
        return te.ticket_number.id === ticketNumber.id;
      }
      return null;
    });
  };

  const returnFormattedCellData = (dailyTimeEntry, user, date) => {
    const { hasTimeEntries, paidPerDiem, ticketNumbers, timeEntries } = dailyTimeEntry;
    if (hasTimeEntries) {
      if (ticketNumbers.length > 0) {
        const backgroundColorClass = (paidPerDiem) ? 'paid-per-diem' : 'unpaid-per-diem';

        const url = getUserTimesheetLink(user.id, moment(date.iso8601));
        return (
          <div style={{ margin: '2px 2px 0px 2px' }}>
            {ticketNumbers.map((tn) => {
              const matchingTimeEntry = returnHoursForTicketNumber(tn, timeEntries);
              const { ticket } = tn;
              if (ticket) {
                const { job } = ticket;
                const ticketUrl = getTicketLink(ticket.id, job.id);
                return (
                  <div className={backgroundColorClass} style={{ marginBottom: '5px' }} key={`${date.iso8601}${user.id}${tn.number}`}>
                    <NewTabLink style={{ display: 'inline-block', paddingRight: '5px' }} to={ticketUrl}> {tn.number}</NewTabLink>
                    <NewTabLink style={{ display: 'inline-block' }} to={url}>
                      {matchingTimeEntry && <span>({matchingTimeEntry.total_hours.to_hours.toFixed(2)} hrs)</span>}
                    </NewTabLink>
                  </div>
                );
              }

              return (
                <div className={backgroundColorClass} style={{ marginBottom: '5px' }} key={`${date.iso8601}${user.id}${tn.number}`}>
                  <span style={{ display: 'inline-block', paddingRight: '5px' }}> {tn.number}</span>
                  <NewTabLink style={{ display: 'inline-block' }} to={url}>
                    {matchingTimeEntry && <span>({matchingTimeEntry.total_hours.to_hours.toFixed(2)} hrs)</span>}
                  </NewTabLink>
                </div>
              );
            })}
          </div>
        );
      }
      return <div> O </div>;
    }
    return <div>X</div>;
  };

  const dayColumns = interval.map((dayObject, index) => {
    return ({
      Header: returnHeader(dayObject),
      id: `${dayObject}${index}`,
      accessor: (allData) => {
        const { hasTimeEntries, ticketNumbers } = allData.userDailyTimeEntries[index];

        if (hasTimeEntries) {
          if (ticketNumbers.length > 0) {
            return ticketNumbers.map((tn) => {
              return tn.number;
            });
          }
          return 'O';
        }
        return 'X';
      },
      Cell: (allData) => {
        const { user, userDailyTimeEntries } = allData.original;
        return returnFormattedCellData(userDailyTimeEntries[index], user, interval[index]);
      },
      minWidth: 75,
    });
  });


  return (
    <div>
      <ReactTable
        data={allDistrictUserDailyTimeEntryGroups}
        filterable
        defaultFilterMethod={(filter, row) => {
          return defaultTableFiltering(filter, row);
        }}
        columns={[
          {
            Header: 'User',
            id: 'fullname',
            accessor: (e) => { return e.user.lastname; },
            filterable: true,
            Cell: (row) => {
              return <span>{row.original.user.fullname}</span>;
            },
          },
          ...dayColumns,
        ]}
        defaultPageSize={10}
        className="-striped -highlight"
      />
    </div>
  );
};

PerDiemReportTable.propTypes = propTypes;
export default PerDiemReportTable;
